import React, { useEffect, useState } from 'react';
import { useBackendApi } from '../../helpers/backendHelper';
import { filterObject, trackClairtyEvent } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import ToggleSwitch from '../action/ToggleSwitch';
import Tooltip from '../action/TooltipWrapper';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import AnalysisTable from './AnalysisTable';

const PositionAnalysis = ({ filters, userAddress, userData, isChain, projectData }) => {
  const TIERS = [0.1, 0.5, 1];
  const [switchOn, setSwitchOn] = useState(false);
  const [activeTier, setActiveTier] = useState(0.1);
  const [compareData, setCompareData] = useState();
  const backendHelper = useBackendApi();

  function handleTier(tier) {
    if (!compareData) return;
    setActiveTier(tier);
  }

  function handleSwitch(value) {
    setSwitchOn(value);
    if (value) {
      compareUserRanking();
    }
  }

  async function compareUserRanking() {
    try {
      setCompareData(null);
      const body = {
        address: userAddress,
        filter: {
          ...filterObject(filters || {}),
          comparision: {
            type: 'aggregate',
            top: activeTier,
          },
        },
      };
      let result;
      
      trackClairtyEvent('profile_position_comparision', {
        project: isChain ? filters?.chainFilter?.chainId : projectData?.name,
        type: activeTier,
      });

      if (isChain) {
        result = await backendHelper.mrep.chainCompareRanking(body);
      } else {
        result = await backendHelper.mrep.compareRanking(body);
      }

      setCompareData(result?.data?.compared);
    } catch (error) {
      console.log('Error', error);
    }
  }

  useEffect(() => {
    if (switchOn) {
      compareUserRanking();
    }
  }, [activeTier]);

  return (
    <FlexboxColumn fw alignItems={'flex-start'}>
      <Flexbox fw justifyContent='space-between'>
        <Flexbox gap='0.5rem'>
          <ThemedText.H4 weight='semi-bold'>Reputation & Positioning Analysis</ThemedText.H4>
          <Tooltip
            position={'right'}
            content={
              'Reputation & Positioning Analysis shows your rank and activity compared to other users. You can see how you measure up against the top 0.1%, 0.5%, and 1%. Your rank reflects engagement, volume tracks total transactions, and rank changes over 7 and 30 days show your progress. Use this to monitor growth and stay competitive.'
            }
          >
            <ThemeLogo icon={'info'} />
          </Tooltip>
          {compareData && switchOn && (
            <Flexbox>
              <Flexbox gap='0.25rem'>
                <div className='analysis_wrapper_box'></div>
                <ThemedText.P>You</ThemedText.P>
              </Flexbox>
              <Flexbox gap='0.25rem'>
                <div className='analysis_wrapper_green_box'></div>
                <ThemedText.P>Compared</ThemedText.P>
              </Flexbox>
            </Flexbox>
          )}
        </Flexbox>

        <Flexbox gap='0.5rem' justifyContent='flex-start'>
          <ThemeLogo icon={'compare'} /> <ThemedText.H5>Position Comparison</ThemedText.H5>
          <ToggleSwitch value={switchOn} onChange={handleSwitch} />
        </Flexbox>
      </Flexbox>

      {switchOn && (
        <Flexbox gap='0.5rem'>
          {TIERS.map(tier => (
            <div className={`analysis_wrapper__switch ${activeTier === tier && 'analysis_wrapper__active'}`} onClick={() => handleTier(tier)}>
              <ThemedText.H6 className='badge_wrapper'>Top {tier}%</ThemedText.H6>
            </div>
          ))}
        </Flexbox>
      )}

      <AnalysisTable userData={userData} compareData={compareData} switchOn={switchOn} projectData={projectData} isChain={isChain} />
    </FlexboxColumn>
  );
};

export default PositionAnalysis;
